import {
  loadPropertyOptions,
  loadUnitOptions
} from "api/landlord/asyncUnitProperties";
import { useState } from "react";
import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { useFormController } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { AsyncSelect } from "shared/components/AsyncSelect/AsyncSelect";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { Lead } from "views/leads-id/types";

export const InterestedInSection = ({
  form,
  wrapperClassName,
  isTitleDisabled = false,
  cardClassName,
  queryLeadData
}: {
  form: ReturnType<typeof useFormController>;
  wrapperClassName?: string;
  isTitleDisabled?: boolean;
  cardClassName?: string;
  queryLeadData?: Lead;
}) => {
  const { Unit, Property } = useUnitsPropertiesDictionary();

  const [unitError, setUnitError] = useState("");
  const [propertyError, setPropertyError] = useState("");

  return (
    <SectionCard
      title="Interested in"
      wrapperClassName={wrapperClassName}
      isTitleDisabled={isTitleDisabled}
      cardClassName={cardClassName}
    >
      <div
        className="grid gap-4 w-full max-w-[752px]"
        style={{ gridTemplateColumns: "repeat(2,minmax(0,1fr))" }}
      >
        <div className="w-full">
          <AsyncSelect
            id="property"
            isClearable
            label={Property}
            value={form.values.property_id || ""}
            searchable={true}
            // @ts-expect-error -- meh
            loadOptions={loadPropertyOptions}
            error={propertyError}
            options={
              form.values.property_id && queryLeadData?.property?.name
                ? [
                    {
                      label: queryLeadData.property.name,
                      value: form.values.property_id
                    }
                  ]
                : []
            }
            onChange={(e) => {
              if (!Array.isArray(e)) {
                const nextValue = e.target.value;
                form.setPropertyId(nextValue ? Number(nextValue) : undefined);
                setPropertyError("");
                form.setUnitId();
              }
            }}
            additional={{
              page: 1
            }}
          />
        </div>
        <div className="w-full">
          <AsyncSelect
            id="unit"
            isClearable
            key={form.values.property_id}
            label={Unit}
            disabled={!form.values.property_id}
            searchable={true}
            value={form.values.unit_id || ""}
            options={
              form.values.unit_id && queryLeadData?.unit?.title
                ? [
                    {
                      label: queryLeadData.unit.title,
                      value: form.values.unit_id
                    }
                  ]
                : []
            }
            // @ts-expect-error -- meh
            loadOptions={loadUnitOptions}
            error={unitError}
            additional={{ page: 1, propertyId: form.values.property_id }}
            onChange={(e) => {
              if (!Array.isArray(e)) {
                const nextValue = e.target.value;
                form.setUnitId(nextValue ? Number(nextValue) : undefined);
                setUnitError("");
              }
            }}
          />
        </div>
      </div>
    </SectionCard>
  );
};
